import React from "react";
import { inputClassName } from "./ui";

export const getAustralianNationalNumber = (value = "") => {
  const raw = String(value).trim();
  let digits = raw.replace(/\D/g, "");

  if (raw.startsWith("+61") || digits.startsWith("61")) {
    digits = digits.slice(2);
  } else if (digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  return digits.slice(0, 9);
};

export const isValidAustralianMobile = (value) =>
  /^4\d{8}$/.test(getAustralianNationalNumber(value));

export const toAustralianE164 = (value) => {
  const national = getAustralianNationalNumber(value);
  return /^4\d{8}$/.test(national) ? `+61${national}` : "";
};

const formatAustralianDisplay = (value = "") => {
  const national = getAustralianNationalNumber(value);
  const groups = [
    national.slice(0, 3),
    national.slice(3, 6),
    national.slice(6, 9),
  ].filter(Boolean);

  return `+61${groups.length ? ` ${groups.join(" ")}` : " "}`;
};

const PhoneInput = ({
  value = "",
  onChange,
  className = "",
  style,
  required = false,
  disabled = false,
  id,
  name,
  autoComplete = "tel",
  ...inputProps
}) => {
  const handleChange = (event) => {
    const raw = event.target.value;
    let digits = raw.replace(/\D/g, "");

    if (raw.trim().startsWith("+61") || digits.startsWith("61")) {
      digits = digits.slice(2);
    } else if (digits.startsWith("0")) {
      digits = digits.slice(1);
    }

    digits = digits.slice(0, 9);
    if (digits && !digits.startsWith("4")) return;
    onChange?.(digits ? `+61${digits}` : "");
  };

  const keepCaretAtEnd = (event) => {
    const input = event.currentTarget;
    requestAnimationFrame(() => {
      const end = input.value.length;
      input.setSelectionRange?.(end, end);
    });
  };

  // PhoneInput deliberately does not merge its light default input styles with
  // a caller-provided className. This makes it a true drop-in input: dark auth
  // forms, light portal forms, compact booking forms, etc. can pass the same
  // className used by their neighbouring inputs without fighting default colors,
  // borders, radii or focus states. With no className it keeps the shared Giggs
  // default input appearance for backwards compatibility.
  const resolvedClassName = className.trim() ? className : inputClassName;

  return (
    <input
      {...inputProps}
      id={id}
      name={name}
      type="tel"
      inputMode="numeric"
      autoComplete={autoComplete}
      className={resolvedClassName}
      style={style}
      value={formatAustralianDisplay(value)}
      onChange={handleChange}
      onFocus={keepCaretAtEnd}
      onClick={keepCaretAtEnd}
      required={required}
      disabled={disabled}
      pattern="\+61 4\d{2} \d{3} \d{3}"
      title="Enter an Australian mobile number, for example +61 412 345 678"
    />
  );
};

export default PhoneInput;
